const tipos = {
  SolicitarCadastroProcessoDistribuido: 1,
  SolicitarAtualizacaoGcpj: 3,
  AtualizarGcpj: 4,
  SolicitarPagamentoCustas: 5,
  PagarCustas: 6,
  JuntarPagamentoCustasAoProcesso: 7,
  AlterarResponsavelProcessual: 10,
  SolicitarCadastroProcessoContrario: 11,
  SolicitarCadastroProcessoTrabalhista: 12,
  SolicitarCadastroProcessoRedistribuido: 14,
  SolicitarServicoCdi: 29,
  AtenderSolicitacaoCdi: 30,
  RegistrarPesquisaBens: 34,
  SolicitarAlteracaoPasta: 35,
  AlterarPasta: 36,
  SolicitarCadastroProcessoVinculado: 37,
  MigrarProcessoNovajus: 38,
  SolicitarCadastroProcessoAvulso: 39,
  EnviarPlanilhaAtualizacaoDebito: 50,
  ConfirmarEnvioPlanilhaAtualizacaoDebitoAoBanco: 51,
  CriarCompromissoPub: 59,
  EnviarArquivos: 61,
  TentarContatoTelefonico: 62,
  RegistrarAndamentoProcessual: 63,
  SolicitarEncerramento: 64,
  AtenderEncerramento: 65,
  AtualizarGcpjEncerramento: 66,
  VerificarEncerramentoGcpj: 67,
  SolicitarHonorariosIrrecuperabilidade: 68,
  ReiterarEncerramento: 69,
  AlterarResponsavelNegocial: 70,
  ConcluirFluxo: 71,
  CriarCompromissoCaq: 72,
  CriarCompromissoResponsavel: 74,
  CumprirCompromissoResponsavel: 75,
  CaqPrazoFatal: 76,
  CaqInconsistencia: 77,
  CaqDecursoDePrazo: 78,
  CaqCumprimentoDePrazoNaoIdentificado: 79,
  CaqGcpjDesatualizado: 80,
  CaqAnalisarViabilidadeDeEncerramento: 81,
  CaqAlerta: 82,
  CaqCumprimentoDePrazoParcialmenteIdentificado: 83,
  CaqPrazoRequeridoEmDilacaoExpirado: 84,
  JuntarPlanilhaAtualizacaoDebitoAoProcesso: 85,
  CaqBloqueioPotencial: 86,
  EnviarPlanilhaAtualizacaoDebitoAtualizada: 87,
  PubSentencaFavoravel: 88,
  PubSentencaDesfavoravel: 89,
  PubDecisaoInterlocutoria: 90,
  PubAudiencia: 91,
  PubDespacho: 92,
  PubManifestacao: 93,
  PubObrigacaoFazer: 94,
  PubContestacao: 95,
  PubCustas: 96,
  PubAgravoInstrumento: 97,
  PubApelacao: 98,
  PubPrazo: 99,
  PubAtoOrdinatorio: 100,
  PubEmenda: 101,
  PubSuspensao: 102,
  PubExtincao: 103,
  PubPrescricao: 104,
  PubCitacao: 105,
  PubCumprimentoSentenca: 106,
  PubPendenteLeituraIntimacao: 107,
  ConfirmarEnvioCustasParaPagamento: 108,
  PublicacaoCapturada: 109,
  AprovarSolicitacaoServicoCdi: 110,
  IncluirAcordoGcpj: 111,
  EnviarEmailAcordoAoBanco: 112,
  RemoverProcessoPlanilhaControleAjuizamento: 113,
  SolicitarInclusaoAcordoCarteiraVeiculosRealizadoAntesAjuizamento: 114,
  IncluirAcordoCarteiraVeiculosRealizadoAntesAjuizamento: 115,
  SolicitarVerificacaoPublicacaoCapturada: 116,
  VerificarPublicacaoOuAndamentoCapturado: 117,
  SolicitarVerificacaoAndamentoCapturado: 118,
  RegistrarOcorrenciaAtendimento: 119,
  CaqVerificarPublicacaoAndamentoProcessual: 120,
  CaqVistoria: 121,
  CaqVesperaAudiencia: 122,
  PubPlanilhaAtualizada: 123,
  PubCustasPlanilhaAtualizada: 124,
  PubApresentarCedulaCredito: 125,
  RegistrarPesquisaCdi: 126,
  SolicitarEnvioEmailAndamento: 127,
  EnviarEmailAndamento: 128,
  AprovarServicoCdiPeloGerenteGgp: 129,
  RegistrarEncerramentoRcb: 130,
  SolicitarTransferenciaPastaParaArquivoMorto: 131,
  AprovarTransferenciaPastaParaArquivoMorto: 132,
  TransferenciaPastaParaArquivoMortoNaoAprovada: 133,
  SolicitarTransferenciaResponsavelProcessualDaPastaParaOutraArea: 134,
  AprovarTransferenciaResponsavelProcessualDaPastaParaOutraArea: 135,
  TransferenciaResponsavelProcessualDaPastaParaOutraAreaNaoAprovada: 136,
  SolicitarTransferenciaResponsavelNegocialDaPastaParaOutraArea: 137,
  AprovarTransferenciaResponsavelNegocialDaPastaParaOutraArea: 138,
  TransferenciaResponsavelNegocialDaPastaParaOutraAreaNaoAprovada: 139,
  SolicitarAcompanhamentoPagamentoHonorarios: 140,
  ConfirmarPagamentoParcelaHonorarios: 141,
  PagamentoParcelaHonorariosNaoRealizado: 142,
  ContinuarAcompanhamentoPagamentoHonorarios: 143,
  AdicionarPastaBaseAtiva: 144,
  RemoverPastaBaseAtiva: 145,
  AlterarGerenteNegocialResponsavel: 146,
  SolicitarVerificacaoNecessidadeCadastroPublicacaoCapturada: 147,
  VerificarNecessidadeCadastroPublicacaoCapturada: 148,
  VerificarNecessidadeCadastroPublicacaoCapturadaPub: 149,
  CriarCompromissoAvulso: 150,
  CumprirCompromissoAvulso: 151,
  ConcluirFluxo2: 152,
  SolicitarAjuizamento: 153,
  ConfirmarAjuizamento: 154,
  EnviarEmailConfirmacaoAjuizamentoAgencia: 155,
  AlterarPastaParaPreencherCamposDeep: 156,
  ImportarPastaPlanilhaBradesco: 157,
  BaixarInformacoesPastaSistemaGcpj: 158,
  ImportarPastasPlanilhaBradesco: 159,
  ExecutarRoboConsultaGcpj: 160,
  SolicitarSubsidio: 161,
  VerificarSubsidio: 162,
  AnexarDocumentosAoGcpj: 163,
  EnviarDocumentosAoGcpj: 164,
  AlterarPasta2: 165,
  ExecutarRoboEnviarDocumentosGcpj: 166,
  ExecutarRoboAtualizacaoGcpj: 167,
  SolicitarEnvioDocumentoAoGcpj: 168,
  ExecutarRoboEncerramentoGcpj: 169,
  PreencherInformacoesNecessariasDistribuicaoPasta: 170,
};

export default tipos;

export function getCaqEnumValues(): number[]
{
  return Object.keys(tipos)
    .filter(key => key.startsWith('Caq'))
    .map(key => tipos[key as keyof typeof tipos]);
}
